import { createRouter, createWebHistory } from 'vue-router';
import LoginPage from '@/components/Auth/LoginPage.vue';
import RegisterPage from '@/components/Auth/RegisterPage.vue';
import DocumentVerification from '@/components/Auth/DocumentVerifications.vue';
import ForgotPasswordPage from '@/components/Auth/ForgotPassword.vue';
import ResetPasswordPage from '@/components/Auth/ResetPassword.vue';
import DashboardPage from '@/components/Dashboard/DashboardPage.vue';
import OtpPage from '@/components/Auth/OtpPage.vue';
import AadharOtp from '@/components/Auth/AadharOtp.vue';
import SetupPassword from '@/components/Auth/SetupPassword';
import ChangePassword from '@/components/Auth/UpdatePassword.vue';
import unauthorisedUser from '@/components/Auth/UnauthorisedUser.vue';
import OurServices from '@/Views/Pages/UserServices/OurServices.vue';
import ServiceDetails from '@/Views/Pages/UserServices/ServiceDetails.vue';
import BBPSService from '@/Views/Pages/UserServices/BBPSService.vue';
import PaymentStatus from '@/Views/Pages/UserServices/PaymentStatus.vue';
import UserProfile from '@/components/Auth/UserProfile.vue';
import EducationFee from '@/Views/Pages/EducationFeePayments/EducationFee.vue'
import RentPayment from '@/Views/Pages/RentalPayments/RentPayment.vue';
import PayAmount from '@/Views/Pages/RentalPayments/PayAmount.vue';
import ThankYou from '@/Views/Pages/UserServices/ThankYouPage.vue';
import AddRentalPayment from '@/Views/Pages/RentalPayments/AddRentPayment.vue';
import VendorPaymentDetails from '@/Views/Pages/VendorPayments/VendorPaymentDetails.vue';
import AddVendorPayment from '@/Views/Pages/VendorPayments/AddVendorPayment.vue';
import VendorPayAmount from '@/Views/Pages/VendorPayments/VendorPayAmount.vue';
import ViewRentalUserDetails from '@/Views/Pages/RentalPayments/ViewRentalUserDetails.vue'
import ViewVendorUserDetails from '@/Views/Pages/VendorPayments/ViewVendorUserDetails.vue';
import viewStudentBillDetails from '@/Views/Pages/EducationFeePayments/ViewStudentBillDetails.vue';
import EditRentalUserDetails from '@/Views/Pages/RentalPayments/EditRentalUserDetails.vue';
import editDetails  from '@/Views/Pages/VendorPayments/EditVenderUserDetails.vue';
import UserDetails from '@/Views/Pages/UserManagement/UserDetails.vue';
import AddUser from '@/Views/Pages/UserManagement/AddUser.vue';
import EditUserDetails from '@/Views/Pages/UserManagement/EditUserDetails.vue';
import ViewUserDetails from '@/Views/Pages/UserManagement/ViewUserDetails.vue';
import GroupCharges from '@/Views/Pages/Settings/GroupCharges.vue';
import CommissionCharges from '@/Views/Pages/Settings/CommissionCharges.vue';
import AddGroupCharges from '@/Views/Pages/Settings/AddGroupCharges.vue'
import AddSchool from '@/Views/Pages/EducationFeePayments/AddSchool';
import UserReports from '@/Views/Pages/Reports/UserReports.vue';
import ViewReports from '@/Views/Pages/Reports/ViewReports.vue';
import UserSupport from '@/Views/Pages/Help/UserSupport.vue';
import CreateTicket from '@/Views/Pages/Help/CreateTicket.vue';
import EditTicket from '@/Views/Pages/Help/EditTicket.vue';
import  DonationPayments from '@/Views/Pages/DonationPayments/DonationPaymentDetails.vue';
import AddDonationPayment from '@/Views/Pages/DonationPayments/AddDonationPayment.vue';
import EditDonationPaymentDetails from '@/Views/Pages/DonationPayments/EditDonationPaymentDetails.vue';
import ViewDonationPaymentDetail from '@/Views/Pages/DonationPayments/ViewDonationPayment.vue';
import PayDonationPayment from '@/Views/Pages/DonationPayments/PayDonationPayment.vue';
import CaRelatedPayment from '@/Views/Pages/CARelatedPayments/CARelatedPaymentsDetails.vue';
import AddCaRelatedPayments from '@/Views/Pages/CARelatedPayments/AddCARelatedPayments.vue';
import EditCARelatedPayments from '@/Views/Pages/CARelatedPayments/EditCARelatedPayments.vue';
import ViewCARelatedPayments from '@/Views/Pages/CARelatedPayments/ViewCARelatedPayments.vue';
import PayCAPaymentPayment from '@/Views/Pages/CARelatedPayments/CARelatedPayAmount.vue';
import SalaryPayment from '@/Views/Pages/SalaryPayments/SalaryPaymentDetails.vue';
import AddSalaryPayment from '@/Views/Pages/SalaryPayments/AddSalaryPayment.vue';
import ViewSalaryPayment from '@/Views/Pages/SalaryPayments/ViewSalaryPayment.vue';
import EditSalaryPayment from '@/Views/Pages/SalaryPayments/EditSalaryPaymentDetails.vue';
import SalaryPayAmount from '@/Views/Pages/SalaryPayments/SalaryPayAmount.vue';
import LegalServiceFee from '@/Views/Pages/LegalServicesFee/LegalServiceFeeDetails.vue';
import AddLegalServicePayment from '@/Views/Pages/LegalServicesFee/AddLegalServicePayment.vue';
import EditLegalServicePayment from '@/Views/Pages/LegalServicesFee/EditLegalServicePayment.vue';
import ViewLegalServicePayment from '@/Views/Pages/LegalServicesFee/ViewLegalServicePayment.vue';
import PayLegalPayment from '@/Views/Pages/LegalServicesFee/LegalPayAmount.vue';
import AssignGroupCharges from '@/Views/Pages/Settings/AssignGroupChargesForUsers.vue';
import EditGroupCharges from '@/Views/Pages/Settings/EditGroupCharges.vue';
import UnAssignGroupCharges from '@/Views/Pages/Settings/UnAssignGroupCharges.vue';
import PaymentConfiguration from '@/Views/Pages/Settings/PaymentConfiguration.vue';
import PaymentPriority from '@/Views/Pages/Settings/PaymentPriority.vue';
import ServicePaymentConfiguration from '@/Views/Pages/Settings/ServicePaymentConfiguration.vue'
import CustomerCharges from '@/Views/Pages/Settings/CustomerCharges.vue';
import CreditCardPayments from '@/Views/Pages/FeeByCreditCard/CreditCardPayment.vue';
import BBPsPaymentStatus from '@/Views/Pages/UserServices/BBPsPaymentStatus.vue';

const routes = [
  {  
    path: '/login',
    name: 'Login',
    component: LoginPage,
    alias: '/', 
  },
  {
    path: '/otp/:userId',
    name: 'OtpPage',
    component: OtpPage,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/register',
    name: 'Register',
    component: RegisterPage
  },
  {
    path: '/forgot-password',
    name: 'ForgotPassword',
    component: ForgotPasswordPage,
  },
  {
    path: '/document-verification',
    name: 'document-verification',
    component: DocumentVerification,
  },
  {
    path: '/status-verification',
  },
  {
    path: '/aadhar-otp',
    name: 'aadhar-otp',
    component: AadharOtp,
  },
  {
    path: '/setup-password/:token/:email',
    name: 'SetupPassword',
    component: SetupPassword,
  },
  {
    path: '/reset-password/:token/:email',
    name: 'ResetPassword',
    component: ResetPasswordPage,
  },
  {
    path: '/services',
    name: 'OurServices',
    component: OurServices,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/user-profile',
    name: 'UserProfile',
    component: UserProfile,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/service-details/:serviceName/:serviceId',
    name: 'ServiceDetails',
    component: ServiceDetails,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/service-category/:serviceId/:category_id',
    name: 'service-category',
    component: BBPSService,
    props: true,
    meta: {
      requiresAuth: true
    }
  },

  {
    path: '/dashboard',
    name: 'Dashboard',
    component: DashboardPage,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/payment-status/:order_id',
    name: 'PaymentStatus',
    component: PaymentStatus,
    meta: {
      requiresAuth: true
    }
   
  },
    {
    path: '/bbps-payment-status/:order_id',
    name: 'BBPsPaymentStatus',
    component: BBPsPaymentStatus,
    meta: {
      requiresAuth: true
    }
   
  },
  {
    path: '/thank-you',
    name: 'ThankYou',
    component: ThankYou,
    meta: {
      requiresAuth: true
    }
  },
  {
    path:'/update-password',
    name:'ChangePassword',
    component:ChangePassword,
    props:true,
  },
  {
    path:'/Unauthorized',
    name:'Unauthorized',
    component:unauthorisedUser,
  },
  {
    path: '/education-fee/:serviceId',
    name: 'EducationFee',
    component: EducationFee,
    props: true,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/category/:serviceId',
    name: 'RentPayment',
    component: RentPayment,
    props: true,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/view-rent-details/:serviceId/:id',
    name: 'ViewRentalUserDetails',
    component: ViewRentalUserDetails,
    props: true,
    meta: {
      requiresAuth: true
    }
    
  },
  {
    path:'/view-student-bill/:uniqueId',
    name:'viewStudentBillDetails',
    component:viewStudentBillDetails,
    props:true,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/view-vendor-details/:serviceId/:id',
    name: 'ViewVendorUserDetails',
    component: ViewVendorUserDetails,
    props: true,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/add-school/:serviceId',
    name: 'AddSchool',
    component: AddSchool,
    props: true,
    meta: {
      requiresAuth: true
    }
  },
  {
    path:'/vendor-payments/:serviceId',
    name: 'VendorPayment',
    component: VendorPaymentDetails,
    props: true,
    meta: {
      requiresAuth: true
    }
  },
  {
    path:'/vendor-pay-amount/:serviceId/:id?',
    name: 'VendorPayAmount',
    component: VendorPayAmount,
    props: true,
    meta: {
      requiresAuth: true
    }
  },
  
  {
    path:'/add-vendor-payments/:serviceId',
    name: 'AddVendorPayment',
    component: AddVendorPayment,
    props: true,
    meta: {
      requiresAuth: true
    }
  },
  {
    path:'/user-reports',
    name: 'UseReports',
    component: UserReports,
    props: true,
    meta: {
      requiresAuth: true
    }
  },
  {
    path:'/user-support',
    name: 'UserSupport',
    component: UserSupport,
    props: true,
    meta: {
      requiresAuth: true
    }
  },
  {
    path:'/donation-payments/:serviceId',
    name: 'DonationPayments',
    component: DonationPayments,
    props: true,
    meta: {
      requiresAuth: true
    }
  },
  {
    path:'/edit-donation-payments/:serviceId/:id',
    name: 'EditDonationPaymentDetails',
    component: EditDonationPaymentDetails,
    props: true,
    meta: {
      requiresAuth: true
    }
  },
  {
    path:'/view-donation-payments/:serviceId/:id',
    name: 'ViewDonationPaymentDetail',
    component: ViewDonationPaymentDetail,
    props: true,
    meta: {
      requiresAuth: true
    }
  },
  {
    path:'/add-donation-payments/:serviceId',
    name: 'AddDonationPayment',
    component: AddDonationPayment,
    props: true,
    meta: {
      requiresAuth: true
    }
  },

  {
    path:'/pay-donation-payment/:serviceId/:id?',
    name: 'PayDonationPayment',
    component: PayDonationPayment,
    alias:'/pay-donation-payments',
    props: true,
    meta: {
      requiresAuth: true
    }
  },
  {
    path:'/salary-payment/:serviceId',
    name: 'SalaryPayment',
    component: SalaryPayment,
    props: true,
    meta: {
      requiresAuth: true
    }
  },
  {
    path:'/add-salary-payment/:serviceId',
    name: 'AddSalaryPayment',
    component: AddSalaryPayment,
    props: true,
    meta: {
      requiresAuth: true
    }
  },
  {
    path:'/view-salary-payment/:serviceId/:id',
    name: 'ViewSalaryPayment',
    component: ViewSalaryPayment,
    props: true,
    meta: {
      requiresAuth: true
    }
  },
  {
    path:'/edit-salary-payment/:serviceId/:id',
    name: 'EditSalaryPayment',
    component: EditSalaryPayment,
    props: true,
    meta: {
      requiresAuth: true
    }
  },
  {
    path:'/salary-pay-amount/:serviceId/:id?',
    name: 'SalaryPayAmount',
    component: SalaryPayAmount,
    props: true,  
    meta: {
      requiresAuth: true
    }
  },
  {
    path:'/legal-service-fee-details/:serviceId',
    name:'LegalServiceFee',
    component:LegalServiceFee,
    props:true,
    meta:{
      requiresAuth:true
    }
  },
  {
    path:'/add-legal-service-fee-details/:serviceId',
    name:'AddLegalServicePayment',
    component:AddLegalServicePayment,
    props:true,
    meta:{
      requiresAuth:true
    }
  },
  {
    path:'/edit-legal-service-fee-details/:serviceId/:id',
    name:'EditLegalServicePayment',
    component:EditLegalServicePayment,
    props:true,
    meta:{
      requiresAuth:true
    }
  },
  {
    path:'/view-legal-service-fee-details/:serviceId/:id',
    name:'ViewLegalServicePayment',
    component:ViewLegalServicePayment,
    props:true,
    meta:{
      requiresAuth:true
    }
  },
  {
    path:'/pay-legal-fee-details/:serviceId/:id?',
    name:'PayLegalPayment',
    component:PayLegalPayment,
    props:true,
    meta:{
      requiresAuth:true
    }
  },
  {
    path:'/create-ticket',
    name: 'CreateTicket',
    component: CreateTicket,
    props: true,
    meta: {
      requiresAuth: true
    }
  },
  {
    path:'/edit-ticket/:id',
    name: 'EditTicket',
    component: EditTicket,
    props: true,
    meta: {
      requiresAuth: true
    }
  },
  {
    path:'/view-reports/:id',
    name: 'ViewReports',
    component: ViewReports,
    props: true,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/pay-amount/:serviceId/:id?',
    name: 'PayAmount',
    component: PayAmount,
    props: true,
    meta: {
      requiresAuth: true
    }
  },
  
  {
    path:'/edit-rental-details/:serviceId/:id',
    name:'EditRentalUserDetails',
    component:EditRentalUserDetails,
    props:true,
    meta: {
      requiresAuth: true
    }
  },
  {
    path:'/edit-vender-user-details/:serviceId/:id',
    name:"editDetails",
    component:editDetails,
    props:true,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/add-rental-payment/:serviceId',
    name: 'AddRentalPayment',
    component: AddRentalPayment,
    props: true,
    meta: {
      requiresAuth: true
    }
  },
  {
    path:'/user-details/:role',
    name:'UserDetails',
    component:UserDetails,
    props: true,
    meta: {
      requiresAuth: true
    }
  },
  {
    path:'/add-user/:role',
    name:'AddUser',
    component:AddUser,
    props: true,
    meta: {
      requiresAuth: true
    }
  },
  {
    path:'/edit-user/:role/:id',
    name:'EditUserDetails',
    component:EditUserDetails,
    props: true,
    meta: {
      requiresAuth: true
    }
  },
  {
    path:'/view-user/:role/:id',
    name:'ViewUserDetails',
    component:ViewUserDetails,
    props: true,
    meta: {
      requiresAuth: true
    }
  },
  {
    path:'/charges',
    name:'GroupCharges',
    component:GroupCharges,
    props: true,
    meta: {
      requiresAuth: true
    }
  },
  {
    path:'/customer-charges',
    name:'Customer Charges',
    component:CustomerCharges,
    props: true,
    meta: {
      requiresAuth: true
    }
  },
  {
    path:'/commissions',
    name:'Commissions',
    component:CommissionCharges,
    props: true,
    meta: {
      requiresAuth: true
    }
  },
  {
    path:'/add-group-charges',
    name:'AddGroupCharges',
    component:AddGroupCharges,
    props: true,
    meta: {
      requiresAuth: true
    }
  },
  {
    path:'/edit-group-charges/:id',
    name:'EditGroupCharges',
    component:EditGroupCharges,
    props: true,
    meta: {
      requiresAuth: true
    }
  },
  {
    path:'/assign-group-charges/:id/:role_id',
    name:'AssignGroupCharges',
    component:AssignGroupCharges,
    props: true,
    meta: {
      requiresAuth: true
    }
  },
  {
    path:'/unassign-group-charges',
    name:'UnAssignGroupCharges',
    component:UnAssignGroupCharges,
    props: true,
    meta: {
      requiresAuth: true
    }
  },
  {
    path:'/payment-configuration',
    name:'Payment Configuration',
    component:PaymentConfiguration,
    props: true,
    meta: {
      requiresAuth: true
    }
  },
  {
    path:'/payment-priorities',
    name:'PaymentPriority',
    component:PaymentPriority,
    props: true,
    meta: {
      requiresAuth: true
    }
  },
  {
    path:'/service-payment-configuration',
    name:'ServicePaymentConfiguration',
    component:ServicePaymentConfiguration,
    props: true,
    meta: {
      requiresAuth: true
    }
  },
   {
    path:'/fee-by-credit-card/:serviceId',
    name:'CreditCardPayments',
    component:CreditCardPayments,
    props: true,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/ca-related-payments/:serviceId',
    name: 'CaRelatedPayment',
    component: CaRelatedPayment,
    props: true,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/add-ca-related-payments/:serviceId',
    name: 'AddCaRelatedPayments',
    component: AddCaRelatedPayments,
    props: true,
    meta: {
      requiresAuth: true
    }
  },
  {
    path:'/edit-ca-related-payments/:serviceId/:id',
    name:'EditCARelatedPayments',
    component:EditCARelatedPayments,
    props:true,
    meta:{
      requiresAuth:true,
    }
  },
  {
    path:'/view-ca-related-payments/:serviceId/:id',
    name:'ViewCARelatedPayments',
    component:ViewCARelatedPayments,
    props:true,
    meta:{
      requiresAuth:true,
    }
  },
  {
    path:'/ca-related-pay/:serviceId/:id?',
    name:'PayCAPaymentPayment',
    component:PayCAPaymentPayment,
    props:true,
    alias:'/ca-related-pay',
    meta:{
      requiresAuth:true,
    }
  },
 
  {
    path: '/:pathMatch(.*)*',
    name: 'CatchAll',
    redirect: { name: 'Unauthorized' },
  },
 
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});




router.beforeEach((to, from, next) => {
  const userId = localStorage.getItem('User_id');
  const roleId = localStorage.getItem('role_id')

  // Handle the case where user is logged in but trying to access an unauthorized page
  if (to.meta.requiresAuth && !userId) {
    next({ name: 'Login' });
    return;
  }

  //to restrict login user as superadmin then he can add only admin 
  if (to.name === 'AddUser' && roleId === '1') {
      const targetRole = to.params.role;
      if (targetRole === 'distributor' || targetRole === 'retailer') {
        next({ name: 'Unauthorized' });
        return;
      }
    }

     //to restrict login user as admin then he can add only distributor and retailer
  if (to.name === 'AddUser' && roleId === '2') {
      const targetRole = to.params.role;
      if (targetRole === 'admin' ) {
        next({ name: 'Unauthorized' });
        return;
      }
    }
    //to restrict the login user as distributor ge can add only retailer 
    if (to.name === 'AddUser' && roleId === '3') {
      const targetRole = to.params.role;
      if (targetRole === 'admin' || targetRole === 'distributor' ) {
        next({ name: 'Unauthorized' });
        return;
      }
    }

    //login user as retailer then he can't add any thing

     if (to.name === 'AddUser' && roleId === '4') {
      const targetRole = to.params.role;
      if (targetRole === 'admin' || targetRole === 'distributor' || targetRole === 'retailer' ) {
        next({ name: 'Unauthorized' });
        return;
      }
    }
  // Handle user role checks if needed
  if ((roleId == '3' || roleId == '4' )) {
    if (to.name === 'Commissions' || to.name === 'AddGroupCharges' || to.name ==='EditGroupCharges' || to.name === 'AssignGroupCharges' 
      || to.name === 'Payment Configuration' || to.name === 'PaymentPriority' || to.name ==='Customer Charges' || to.name ==='ServicePaymentConfiguration'
    ) {
      next({ name: 'Unauthorized' });
      return;
    }
  }

  if((roleId =='2'))
  {
    if(to.name ==='ServicePaymentConfiguration' || to.name == 'Customer Charges')
    {
      next({name:'Unauthorized'});
      return;
    }
  }

  //only retailer access the utility

  if((roleId == '1' || roleId == '2' || roleId == '3'))
  {
    if(to.name === 'ServiceDetails' || to.name ==='service-category'|| to.name === 'OurServices'){
      next({ name: 'Unauthorized' });
      return;
    }
  }
if((roleId == '1' || roleId == '2' || roleId == '3')){
  if(to.name === 'EducationFee' || to.name === 'AddSchool')
  {
    next({ name: 'Unauthorized' });
      return;
  }
}

//only retailer to access the vendor payments
if((roleId == '1' || roleId == '2' || roleId == '3')){
  if(to.name === 'VendorPayment' || to.name === 'VendorPayAmount'|| to.name === 'AddVendorPayment' || to.name === 'editDetails')
  {
    next({ name: 'Unauthorized' });
      return;
  }
}
//only retailer to access the donation payments

if((roleId == '1' || roleId == '2' || roleId == '3')){
  if(to.name === 'DonationPayments' || to.name === 'EditDonationPaymentDetails'|| to.name === 'ViewDonationPaymentDetail'  || to.name === 'AddDonationPayment' || to.name==='PayDonationPayment')
  {
    next({ name: 'Unauthorized' });
      return;
  }
}
//only retailer to access the salary payments

if((roleId == '1' || roleId == '2' || roleId == '3')){
  if(to.name === 'SalaryPayment' || to.name === 'AddSalaryPayment'|| to.name === 'ViewSalaryPayment'  || to.name === 'EditSalaryPayment' || to.name==='SalaryPayAmount')
  {
    next({ name: 'Unauthorized' });
      return;
  }
}
//only retailer to access the legal payments
if((roleId == '1' || roleId == '2' || roleId == '3')){
  if(to.name === 'LegalServiceFee' || to.name === 'AddLegalServicePayment'|| to.name === 'EditLegalServicePayment'  || to.name === 'ViewLegalServicePayment' || to.name==='PayLegalPayment')
  {
    next({ name: 'Unauthorized' });
      return;
  }
}

//handle login user as super admin then he can't access the create ticket

if((roleId == '1')){
  if (to.name === 'CreateTicket') {
    next({ name: 'Unauthorized' });
    return;
  }
  
}
//handle the services  to adding category only retailer

if((roleId == '1' || roleId == '2' || roleId == '3')){
  if (to.name === 'AddRentalPayment' || to.path.startsWith('/add-rental-payment/') || to.name ==='PayAmount') {
    next({ name: 'Unauthorized' });
    return;
  }
  
}
//only retailer access the services of CaPayments
if((roleId == '1' || roleId == '2' || roleId == '3')){
  if (to.name === 'CaRelatedPayment' || to.name ==='AddCaRelatedPayments' || to.name === 'EditCARelatedPayments' || to.name ==='ViewCARelatedPayments'){
    next({ name: 'Unauthorized' });
    return;
  }

}


//only superadmin to shown the payment-configuration

if((roleId == '2' || roleId == '3' || roleId == '4'))
{
  if(to.name === 'Payment Configuration' ||to.name === 'PaymentPriority')
  {
     next({ name: 'Unauthorized' });
    return;
  }
}
if((roleId == '1' || roleId == '2' || roleId == '3'))
{
  if(to.name === 'PaymentStatus' )
  {
     next({ name: 'Unauthorized' });
    return;
  }
}
  // Proceed with navigation if no conditions block it
  next();
});


router.afterEach((to) => {
  if (to.name === 'Login') {
    localStorage.removeItem('authToken'); 
    localStorage.removeItem('User_id');
  }
});

export default router;
